"use client"

import { mapModifiers } from '@/utils/funtion';
import React from 'react';
import { Skeleton as CSkeleton } from 'antd';

type SkeletonType = 'button' | 'avatar' | 'input' | 'node' | 'image' | 'default' | undefined;

interface SkeletonProps {
    round?: boolean,
    type?: SkeletonType
    avatar?: boolean,
    loading?: boolean,
    paragraph?: any,
    active?: boolean,
    title?: boolean,
    shape?: 'circle' | 'square';
    size?: 'large' | 'small' | 'default';
    sizeAvatar?: 'large' | 'small' | 'default' | number;
    width?: number | string;
    block?: boolean;
    fullSize?: boolean;
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
    type = 'default', title, paragraph, round, loading, avatar, active, shape, size, block, fullSize, children, sizeAvatar, style
}) => {

    const props = {
        active: active,
        avatar: avatar,
        loading: loading,
        paragraph: paragraph,
        round: round,
        title: title,
        style: style,
    }

    const renderSkeleton = () => {
        switch (type) {
            case 'input': return (<CSkeleton.Input {...props} size={size} />)
            case 'avatar': return (<CSkeleton.Avatar {...props} shape={shape} size={sizeAvatar} />)
            case 'button': return (<CSkeleton.Button {...props} size={size} block={block} />)
            case 'node': return (<CSkeleton.Node {...props} fullSize={fullSize} >{children}</CSkeleton.Node>)
            case 'image': return (<CSkeleton.Image {...props} />)
            default: return (<CSkeleton {...props} />)
        }
    }
    return (
        <div className={mapModifiers('a-skeleton', type)}>
            {renderSkeleton()}
        </div>
    );
}

export default Skeleton;
